// Generated by Melange

import * as Belt__Belt_Option from "melange.belt/belt_Option.js";
import * as Buhta_cabinet__Btn from "../../components/html/Btn.js";
import * as Buhta_cabinet__DashboardContentTemplate from "../../templates/DashboardContentTemplate.js";
import * as Buhta_cabinet__Document from "../../grpc/Document.js";
import * as Buhta_cabinet__Dropdowns from "../../components/molecules/Dropdowns.js";
import * as Buhta_cabinet__Field from "../../components/html/Field.js";
import * as Buhta_cabinet__FormView from "../../components/html/FormView.js";
import * as Buhta_cabinet__Link from "../../components/html/Link.js";
import * as Buhta_cabinet__OrgDashboardHeader from "../../components/molecules/OrgDashboardHeader/OrgDashboardHeader.js";
import * as Buhta_cabinet__PhoneField from "../../components/html/PhoneField.js";
import * as Buhta_cabinet__Route from "../../Route.js";
import * as Buhta_cabinet__ToastSender from "../../util/ToastSender.js";
import * as Buhta_components__Text from "../../../../../packages/components/src/html/Text.js";
import * as Buhta_core__GrpcState from "../../../../../packages/core/lib/GrpcState.js";
import * as Buhta_core__Tenant from "../../../../../packages/core/lib/Tenant.js";
import * as Buhta_core__Toast from "../../../../../packages/core/lib/Toast.js";
import * as Curry from "melange.js/curry.js";
import * as Formating from "../../../../../packages/util/lib/Formating.js";
import * as $$Promise from "../../../../../vendored/promise/promise.js";
import * as StaticAsset from "../../../../../packages/util/lib/StaticAsset.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";

const initialData = {
  "type'": undefined,
  country_code: undefined,
  resident: undefined,
  name: undefined,
  email: undefined,
  phone: undefined,
  contact: undefined,
  legal_address: undefined,
  real_address: undefined,
  chief_tin: undefined,
  chief_position: undefined,
  chief_family_name: undefined,
  chief_given_name: undefined,
  chief_patronymic_name: undefined,
  chief_acting_on: undefined,
  kbe: undefined
};

function UpdateContractorPage$ContractorForm(Props) {
  let data = Props.data;
  let onUpdate = Props.onUpdate;
  const match = React.useState(function () {
    return initialData;
  });
  const setContractor = match[1];
  const contractor = match[0];
  const get = function (field) {
    switch (field) {
      case /* Name */ 0 :
        return Belt__Belt_Option.getWithDefault(contractor.name, data.name);
      case /* Legal_address */ 1 :
        return Belt__Belt_Option.getWithDefault(contractor.legal_address, data.legal_address);
      case /* Real_address */ 2 :
        return Belt__Belt_Option.getWithDefault(contractor.real_address, data.real_address);
      case /* Phone */ 3 :
        return Formating.formatPhone(Belt__Belt_Option.getWithDefault(contractor.phone, data.phone));
      case /* Email */ 4 :
        return Belt__Belt_Option.getWithDefault(contractor.email, data.email);
      case /* Contact */ 5 :
        return Belt__Belt_Option.getWithDefault(contractor.contact, data.contact);
      case /* Kbe */ 6 :
        return Belt__Belt_Option.getWithDefault(contractor.kbe, data.kbe);
      case /* Chief_position */ 7 :
        return Belt__Belt_Option.getWithDefault(contractor.chief_position, data.chief_position);
      case /* Chief_family_name */ 8 :
        return Belt__Belt_Option.getWithDefault(contractor.chief_family_name, data.chief_family_name);
      case /* Chief_given_name */ 9 :
        return Belt__Belt_Option.getWithDefault(contractor.chief_given_name, data.chief_given_name);
      case /* Chief_patronymic_name */ 10 :
        return Belt__Belt_Option.getWithDefault(contractor.chief_patronymic_name, data.chief_patronymic_name);
      case /* Chief_tin */ 11 :
        return Belt__Belt_Option.getWithDefault(contractor.chief_tin, data.chief_tin);
      case /* Chief_acting_on */ 12 :
        return Belt__Belt_Option.getWithDefault(contractor.chief_acting_on, data.chief_acting_on);
    }
  };
  const t = contractor["type'"];
  return JsxRuntime.jsxs(Buhta_cabinet__FormView.make, {
    onSubmit: (function (param) {
      Curry._1(onUpdate, contractor);
    }),
    children: [
      JsxRuntime.jsx(Buhta_cabinet__Field.make, {
        label: "Название",
        type_: "text",
        name: "name",
        required: true,
        onChange: (function (value) {
          Curry._1(setContractor, (function (state) {
            return {
              "type'": state["type'"],
              country_code: state.country_code,
              resident: state.resident,
              name: data.name === value ? undefined : value,
              email: state.email,
              phone: state.phone,
              contact: state.contact,
              legal_address: state.legal_address,
              real_address: state.real_address,
              chief_tin: state.chief_tin,
              chief_position: state.chief_position,
              chief_family_name: state.chief_family_name,
              chief_given_name: state.chief_given_name,
              chief_patronymic_name: state.chief_patronymic_name,
              chief_acting_on: state.chief_acting_on,
              kbe: state.kbe
            };
          }));
        }),
        value: get(/* Name */ 0)
      }),
      JsxRuntime.jsx(Buhta_cabinet__Field.make, {
        label: "ИИН/БИН",
        type_: "text",
        name: "tin",
        disabled: true,
        className: "mt-4",
        inputClassName: "text-default-gray safari-disabled-input",
        value: data.tin
      }),
      JsxRuntime.jsx(Buhta_cabinet__Dropdowns.OrgTypeSelect.make, {
        org_type: t !== undefined ? t : data["type'"],
        onOrgTypeSelect: (function (value) {
          Curry._1(setContractor, (function (state) {
            return {
              "type'": data["type'"] === value ? undefined : value,
              country_code: state.country_code,
              resident: state.resident,
              name: state.name,
              email: state.email,
              phone: state.phone,
              contact: state.contact,
              legal_address: state.legal_address,
              real_address: state.real_address,
              chief_tin: state.chief_tin,
              chief_position: state.chief_position,
              chief_family_name: state.chief_family_name,
              chief_given_name: state.chief_given_name,
              chief_patronymic_name: state.chief_patronymic_name,
              chief_acting_on: state.chief_acting_on,
              kbe: state.kbe
            };
          }));
        })
      }),
      JsxRuntime.jsx(Buhta_cabinet__Field.make, {
        label: "Юридический адрес",
        type_: "text",
        name: "legal_address",
        onChange: (function (value) {
          Curry._1(setContractor, (function (state) {
            return {
              "type'": state["type'"],
              country_code: state.country_code,
              resident: state.resident,
              name: state.name,
              email: state.email,
              phone: state.phone,
              contact: state.contact,
              legal_address: data.legal_address === value ? undefined : value,
              real_address: state.real_address,
              chief_tin: state.chief_tin,
              chief_position: state.chief_position,
              chief_family_name: state.chief_family_name,
              chief_given_name: state.chief_given_name,
              chief_patronymic_name: state.chief_patronymic_name,
              chief_acting_on: state.chief_acting_on,
              kbe: state.kbe
            };
          }));
        }),
        className: "mt-4",
        value: get(/* Legal_address */ 1)
      }),
      JsxRuntime.jsx(Buhta_cabinet__Field.make, {
        label: "Фактический адрес",
        type_: "text",
        name: "real_address",
        onChange: (function (value) {
          Curry._1(setContractor, (function (state) {
            return {
              "type'": state["type'"],
              country_code: state.country_code,
              resident: state.resident,
              name: state.name,
              email: state.email,
              phone: state.phone,
              contact: state.contact,
              legal_address: state.legal_address,
              real_address: data.real_address === value ? undefined : value,
              chief_tin: state.chief_tin,
              chief_position: state.chief_position,
              chief_family_name: state.chief_family_name,
              chief_given_name: state.chief_given_name,
              chief_patronymic_name: state.chief_patronymic_name,
              chief_acting_on: state.chief_acting_on,
              kbe: state.kbe
            };
          }));
        }),
        className: "mt-4",
        value: get(/* Real_address */ 2)
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx(Buhta_cabinet__PhoneField.make, {
            value: get(/* Phone */ 3),
            onChange: (function (value) {
              Curry._1(setContractor, (function (state) {
                return {
                  "type'": state["type'"],
                  country_code: state.country_code,
                  resident: state.resident,
                  name: state.name,
                  email: state.email,
                  phone: data.phone === value ? undefined : value,
                  contact: state.contact,
                  legal_address: state.legal_address,
                  real_address: state.real_address,
                  chief_tin: state.chief_tin,
                  chief_position: state.chief_position,
                  chief_family_name: state.chief_family_name,
                  chief_given_name: state.chief_given_name,
                  chief_patronymic_name: state.chief_patronymic_name,
                  chief_acting_on: state.chief_acting_on,
                  kbe: state.kbe
                };
              }));
            })
          }),
          JsxRuntime.jsx(Buhta_components__Text.Caption.make, {
            className: "absolute -top-1.5 left-2 bg-white px-2 text-gray-medium",
            children: "Телефон"
          })
        ],
        className: "mt-4 relative"
      }),
      JsxRuntime.jsx(Buhta_cabinet__Field.make, {
        label: "Почта",
        type_: "email",
        name: "email",
        onChange: (function (value) {
          Curry._1(setContractor, (function (state) {
            return {
              "type'": state["type'"],
              country_code: state.country_code,
              resident: state.resident,
              name: state.name,
              email: data.email === value ? undefined : value,
              phone: state.phone,
              contact: state.contact,
              legal_address: state.legal_address,
              real_address: state.real_address,
              chief_tin: state.chief_tin,
              chief_position: state.chief_position,
              chief_family_name: state.chief_family_name,
              chief_given_name: state.chief_given_name,
              chief_patronymic_name: state.chief_patronymic_name,
              chief_acting_on: state.chief_acting_on,
              kbe: state.kbe
            };
          }));
        }),
        className: "mt-4",
        value: get(/* Email */ 4)
      }),
      JsxRuntime.jsx(Buhta_cabinet__Field.make, {
        label: "Контактное лицо",
        type_: "text",
        name: "contact",
        onChange: (function (value) {
          Curry._1(setContractor, (function (state) {
            return {
              "type'": state["type'"],
              country_code: state.country_code,
              resident: state.resident,
              name: state.name,
              email: state.email,
              phone: state.phone,
              contact: data.contact === value ? undefined : value,
              legal_address: state.legal_address,
              real_address: state.real_address,
              chief_tin: state.chief_tin,
              chief_position: state.chief_position,
              chief_family_name: state.chief_family_name,
              chief_given_name: state.chief_given_name,
              chief_patronymic_name: state.chief_patronymic_name,
              chief_acting_on: state.chief_acting_on,
              kbe: state.kbe
            };
          }));
        }),
        className: "mt-4",
        value: get(/* Contact */ 5)
      }),
      JsxRuntime.jsx(Buhta_cabinet__Field.make, {
        label: "КБе",
        type_: "text",
        name: "kbe",
        onChange: (function (value) {
          Curry._1(setContractor, (function (state) {
            return {
              "type'": state["type'"],
              country_code: state.country_code,
              resident: state.resident,
              name: state.name,
              email: state.email,
              phone: state.phone,
              contact: state.contact,
              legal_address: state.legal_address,
              real_address: state.real_address,
              chief_tin: state.chief_tin,
              chief_position: state.chief_position,
              chief_family_name: state.chief_family_name,
              chief_given_name: state.chief_given_name,
              chief_patronymic_name: state.chief_patronymic_name,
              chief_acting_on: state.chief_acting_on,
              kbe: data.kbe === value ? undefined : value
            };
          }));
        }),
        className: "mt-4",
        value: get(/* Kbe */ 6)
      }),
      JsxRuntime.jsx(Buhta_components__Text.Label.make, {
        className: "mt-6 text-default-gray",
        children: "Руководитель"
      }),
      JsxRuntime.jsx(Buhta_cabinet__Field.make, {
        label: "Должность",
        type_: "text",
        name: "chief_position",
        onChange: (function (value) {
          Curry._1(setContractor, (function (state) {
            return {
              "type'": state["type'"],
              country_code: state.country_code,
              resident: state.resident,
              name: state.name,
              email: state.email,
              phone: state.phone,
              contact: state.contact,
              legal_address: state.legal_address,
              real_address: state.real_address,
              chief_tin: state.chief_tin,
              chief_position: data.chief_position === value ? undefined : value,
              chief_family_name: state.chief_family_name,
              chief_given_name: state.chief_given_name,
              chief_patronymic_name: state.chief_patronymic_name,
              chief_acting_on: state.chief_acting_on,
              kbe: state.kbe
            };
          }));
        }),
        className: "mt-4",
        value: get(/* Chief_position */ 7)
      }),
      JsxRuntime.jsx(Buhta_cabinet__Field.make, {
        label: "Фамилия",
        type_: "text",
        name: "chief_family_name",
        onChange: (function (value) {
          Curry._1(setContractor, (function (state) {
            return {
              "type'": state["type'"],
              country_code: state.country_code,
              resident: state.resident,
              name: state.name,
              email: state.email,
              phone: state.phone,
              contact: state.contact,
              legal_address: state.legal_address,
              real_address: state.real_address,
              chief_tin: state.chief_tin,
              chief_position: state.chief_position,
              chief_family_name: data.chief_family_name === value ? undefined : value,
              chief_given_name: state.chief_given_name,
              chief_patronymic_name: state.chief_patronymic_name,
              chief_acting_on: state.chief_acting_on,
              kbe: state.kbe
            };
          }));
        }),
        className: "mt-4",
        value: get(/* Chief_family_name */ 8)
      }),
      JsxRuntime.jsx(Buhta_cabinet__Field.make, {
        label: "Имя",
        type_: "text",
        name: "chief_given_name",
        onChange: (function (value) {
          Curry._1(setContractor, (function (state) {
            return {
              "type'": state["type'"],
              country_code: state.country_code,
              resident: state.resident,
              name: state.name,
              email: state.email,
              phone: state.phone,
              contact: state.contact,
              legal_address: state.legal_address,
              real_address: state.real_address,
              chief_tin: state.chief_tin,
              chief_position: state.chief_position,
              chief_family_name: state.chief_family_name,
              chief_given_name: data.chief_given_name === value ? undefined : value,
              chief_patronymic_name: state.chief_patronymic_name,
              chief_acting_on: state.chief_acting_on,
              kbe: state.kbe
            };
          }));
        }),
        className: "mt-4",
        value: get(/* Chief_given_name */ 9)
      }),
      JsxRuntime.jsx(Buhta_cabinet__Field.make, {
        label: "Отчество",
        type_: "text",
        name: "chief_patronymic_name",
        onChange: (function (value) {
          Curry._1(setContractor, (function (state) {
            return {
              "type'": state["type'"],
              country_code: state.country_code,
              resident: state.resident,
              name: state.name,
              email: state.email,
              phone: state.phone,
              contact: state.contact,
              legal_address: state.legal_address,
              real_address: state.real_address,
              chief_tin: state.chief_tin,
              chief_position: state.chief_position,
              chief_family_name: state.chief_family_name,
              chief_given_name: state.chief_given_name,
              chief_patronymic_name: data.chief_patronymic_name === value ? undefined : value,
              chief_acting_on: state.chief_acting_on,
              kbe: state.kbe
            };
          }));
        }),
        className: "mt-4",
        value: get(/* Chief_patronymic_name */ 10)
      }),
      JsxRuntime.jsx(Buhta_cabinet__Field.make, {
        label: "ИИН",
        type_: "text",
        name: "chief_tin",
        onChange: (function (value) {
          Curry._1(setContractor, (function (state) {
            return {
              "type'": state["type'"],
              country_code: state.country_code,
              resident: state.resident,
              name: state.name,
              email: state.email,
              phone: state.phone,
              contact: state.contact,
              legal_address: state.legal_address,
              real_address: state.real_address,
              chief_tin: data.chief_tin === value ? undefined : value,
              chief_position: state.chief_position,
              chief_family_name: state.chief_family_name,
              chief_given_name: state.chief_given_name,
              chief_patronymic_name: state.chief_patronymic_name,
              chief_acting_on: state.chief_acting_on,
              kbe: state.kbe
            };
          }));
        }),
        className: "mt-4",
        value: get(/* Chief_tin */ 11)
      }),
      JsxRuntime.jsx(Buhta_cabinet__Btn.make, {
        title: "Сохранить",
        className: "py-3 mt-6 w-full",
        type_: "submit"
      })
    ]
  });
}

const ContractorForm = {
  make: UpdateContractorPage$ContractorForm
};

function UpdateContractorPage(Props) {
  let org = Props.org;
  let id = Props.id;
  const match = Buhta_core__Tenant.useTenant(undefined);
  const tenant = match[0];
  const contextRoute = function (route) {
    return Buhta_cabinet__Route.contextRoute(tenant.ctx, org.id, route);
  };
  const match$1 = Buhta_core__Toast.ToastsContext.useToasts(undefined);
  const dispatchToasts = match$1[1];
  const match$2 = React.useState(function () {
    return 1;
  });
  const setRefresh = match$2[1];
  const refresh = match$2[0];
  const func = Buhta_cabinet__Document.ContractorService.view;
  const match$3 = Buhta_core__GrpcState.useModel((function (param) {
    return Curry._3(func, param, /* [] */ 0, id);
  }), undefined);
  const dispatch = match$3[1];
  const item = match$3[0];
  React.useEffect((function () {
    Curry._2(dispatch, undefined, undefined);
  }), [
    id,
    refresh
  ]);
  const header = JsxRuntime.jsx(Buhta_cabinet__OrgDashboardHeader.make, {
    title: typeof item === "string" || item.NAME !== "Data" ? "Загрузка..." : item.VAL.name
  });
  const onUpdate = function (contractor) {
    const __x = Buhta_cabinet__Document.ContractorService.update(tenant, id, contractor);
    $$Promise.get(__x, (function (result) {
      if (result.TAG !== /* Ok */ 0) {
        return Buhta_cabinet__ToastSender.sendGrpcErrorToast(dispatchToasts, result._0, "Ошибка при отправке формы");
      }
      Curry._1(setRefresh, (function (param) {
        return -refresh | 0;
      }));
      Curry._1(dispatchToasts, {
        TAG: /* Add */ 0,
        _0: {
          id: Buhta_core__Toast.generateId(undefined),
          text: "Изменения сохранены",
          kind: "success",
          onClick: (function (param) {
            
          })
        }
      });
    }));
  };
  return JsxRuntime.jsx(Buhta_cabinet__DashboardContentTemplate.make, {
    header: header,
    children: JsxRuntime.jsxs("div", {
      children: [
        JsxRuntime.jsx("div", {
          children: JsxRuntime.jsx(Buhta_cabinet__Link.make, {
            route: contextRoute({
              TAG: /* Manage */ 7,
              _0: {
                TAG: /* Contractors */ 0,
                _0: {
                  TAG: /* View */ 0,
                  _0: id
                }
              }
            }),
            children: JsxRuntime.jsx("img", {
              className: "w-5 h-5",
              src: StaticAsset.src("/static/icons/close-20.svg")
            })
          }),
          className: "bg-white py-4.5 px-6 border-b border-gray-main w-full flex"
        }),
        JsxRuntime.jsx("div", {
          children: typeof item === "string" || item.NAME !== "Data" ? null : JsxRuntime.jsx(UpdateContractorPage$ContractorForm, {
              data: item.VAL,
              onUpdate: onUpdate
            }),
          className: "w-140.5 shadow-card p-10 bg-white mt-10"
        })
      ],
      className: "w-full flex flex-col items-center bg-gray-pale overflow-y-auto pb-10"
    })
  });
}

const make = UpdateContractorPage;

export {
  initialData,
  ContractorForm,
  make,
}
/* Buhta_cabinet__Btn Not a pure module */
